import { ReceiptSelectItemFlightSegment } from '../../interfaces/receipt-select/receipt-select-item-flight-segment';
import { ReceiptSelectItemSection } from '../../interfaces/receipt-select/receipt-select-item-section';
import { ReceiptSelectItemTraveler } from '../../interfaces/receipt-select/receipt-select-item-traveler';

/**
 * 表示内容情報データモデルの実装。
 *
 */
export class ReceiptSelectItemFlightSegmentImpl implements ReceiptSelectItemFlightSegment {
  serviceType?: string;
  constructor(
    public sectionList: ReceiptSelectItemSection[],
    public travelerList: ReceiptSelectItemTraveler[],
    private _isRequiredShowAll: boolean,
    _serviceType?: string
  ) {
    if (_serviceType) {
      this.serviceType = _serviceType;
    }
  }
  get hasSection() {
    // 区間表示がある
    return this.sectionList.length > 0;
  }
  get hasPluralSection() {
    // 複数の区間情報表示がある
    return this.sectionList.length > 1;
  }

  set isRequiredShowAll(flag: boolean) {
    this._isRequiredShowAll = flag;
  }

  get isRequiredShowAll() {
    return this._isRequiredShowAll;
  }
}
